export abstract class TaskManagementConstants {
  /*
  * Export formats
  */
  public static EXPORT_FORMAT_PDF = 'Task_Mgmt_Format_Pdf';
  public static EXPORT_FORMAT_SHP_POLYGON = 'Task_Mgmt_Format_Shape_Polygon';
  public static EXPORT_FORMAT_SHP_MULTIPOLYGON = 'Task_Mgmt_Format_Shape_Multipolygon';
  public static EXPORT_FORMAT_ISO = 'Task_Mgmt_Format_Isoxml';
  public static EXPORT_FORMAT_PFBOX_RST = 'Task_Mgmt_Format_PfBox_rst';

  /*
   * Export targets
   */
  public static EXPORT_TARGET_DOWNLOAD = 'Task_Mgmt_Target_Download';
  // public static EXPORT_TARGET_JD = 'Task_Mgmt_Target_JD'; - not implemented, yet
  public static EXPORT_TARGET_MAIL = 'Task_Mgmt_Target_Mail';
}
